import { FormDivider } from "./styles";

const Divider = ({children}) => {
   return (
      <FormDivider onDividerText={children} />
   );
}

export default Divider;